import videojs from 'video.js';

import './Title.scss';
import { notifyWithFullscreenClose } from '../../utiliti';

class Title extends videojs.getComponent('Component') {
  constructor(player, options) {
    super(player, options);

    this.title_ = options.playerOptions.title || '';

    this.update(this.title_);
  }

  createEl() {
    const el = super.createEl('div', {
      className: 'vjs-title'
    });
    const backImage = videojs.dom.createEl('img', {
      src: 'back.svg',
      className: 'vjs-custom-action-icons'
    });
    const backButton = videojs.dom.createEl('button', {
      className: 'vjs-button vjs-custom-back-button',
      id: 'vjs-custom-back-button'
    });
    backButton.onclick = () => {
      notifyWithFullscreenClose(this.player_, { type: 'BACK_CLICKED' });
    };
    backButton.appendChild(backImage);
    this.contentEl_ = videojs.dom.createEl('div', {
      className: 'vjs-title-field'
    });

    const rightActions = videojs.dom.createEl('div', {
      className: 'vjs-title-right-actions right-actions flex flex-row'
    });

    const pollsImage = videojs.dom.createEl('img', {
      src: 'polls.svg',
      className: 'vjs-custom-action-icons',
      id: 'poll-image'
    });
    const pollsButton = videojs.dom.createEl('button', {
      className: 'vjs-button vjs-custom-poll-button',
      id: 'vjs-custom-poll-button'
    });
    const threeDotsImage = videojs.dom.createEl('img', {
      src: 'threeDots.svg',
      className: 'vjs-custom-action-icons'
    });
    const threeDotsButton = videojs.dom.createEl('button', {
      className: 'vjs-button vjs-custom-three-dots-button',
      id: 'vjs-custom-three-dots-button'
    });
    const reportImage = videojs.dom.createEl('img', {
      src: 'report.png',
      className: 'vjs-custom-action-icons'
    });
    const reportButton = videojs.dom.createEl('button', {
      className: 'vjs-button vjs-custom-report-button',
      id: 'vjs-custom-report-button'
    });
    const joinMeetImage = videojs.dom.createEl('img', {
      src: 'meet.png',
      className: 'vjs-custom-action-icons'
    });
    const joinMeetButton = videojs.dom.createEl('button', {
      className: 'vjs-button vjs-custom-meet-button-hidden',
      id: 'vjs-custom-meet-button'
    });
    reportButton.onclick = () => {
      notifyWithFullscreenClose(this.player_, { type: 'REPORT_CLICKED' });
    };
    joinMeetButton.onclick = () => {
      notifyWithFullscreenClose(this.player_, { type: 'JOIN_MEET_CLICKED' });
    };
    pollsButton.onclick = () => {
      const _el = document.getElementById('vjs-custom-poll-button');
      _el.classList.remove('vjs-custom-poll-received');
      notifyWithFullscreenClose(this.player_, { type: 'POLL_CLICKED' });
    };
    threeDotsButton.onclick = () => {
      notifyWithFullscreenClose(this.player_, { type: 'THREE_DOTS_CLICKED' });
    };
    threeDotsButton.appendChild(threeDotsImage);
    reportButton.appendChild(reportImage);
    joinMeetButton.appendChild(joinMeetImage);
    pollsButton.appendChild(pollsImage);
    rightActions.appendChild(joinMeetButton);
    rightActions.appendChild(pollsButton);
    rightActions.appendChild(reportButton);
    rightActions.appendChild(threeDotsButton);
    el.appendChild(backButton);
    el.appendChild(this.contentEl_);
    el.appendChild(rightActions);

    return el;
  }

  update(title_) {
    if (!title_) {
      this.hide();
    } else {
      this.show();
    }

    this.player_.cache_.title = this.title_;
    this.title_ = title_;

    this.contentEl_.innerHTML = title_;
  }
}

const title = function (title_) {
  const videoTitle = this.player_.getChild('VideoTitle');

  if (typeof title_ === 'undefined') {
    return videoTitle.title_;
  }

  videoTitle.update(title_);
};

videojs.registerPlugin('title', title);
videojs.registerComponent('VideoTitle', Title);

videojs
  .getComponent('Player')
  .prototype.options_.children.splice(2, 0, 'VideoTitle');
